import React from "react";

const LoaderCard = ({ isCategory, classe }) => {
  return (
    <article
      className={`${
        isCategory && "m-4"
      } ${classe} animate-pulse rounded border border-smoot bg-white p-4 shadow-sm`}
    >
      <div className={`${isCategory && "hidden"} flex justify-end`}>
        <span className="block h-2 w-5 rounded bg-smoot"></span>
      </div>
      <div className="mx-auto mt-1 flex h-28 w-full justify-center rounded bg-smoot"></div>

      <div className="mt-3 h-2 w-3/5 rounded bg-smoot"></div>
      <div className="mt-1.5 h-3 w-4/5 rounded bg-smoot"></div>
    </article>
  );
};

export default LoaderCard;
